// extracted by mini-css-extract-plugin
export var boldText = "under-header-module--bold-text--POA6H";
export var container = "under-header-module--container--dJJo8";
export var subTitle = "under-header-module--sub-title--bT2JB";
export var underLine = "under-header-module--under-line--ionMx";
export var underLineTextContainer = "under-header-module--under-line-text-container--0PYvp";
export var underLineTextsContainer = "under-header-module--under-line-texts-container--0IiDg";